import React from 'react';
import UserProfileCard from '../user-profile-card';
import SupportForm from './SupportForm';
import SupportParagraph from './SupportParagraph';

const Contact = () => {
  return (
    <div className="govuk-width-container analytics mt-3">
      <UserProfileCard />
      <SupportParagraph />
      <SupportForm />
    </div>
  );
};

export default Contact;
